var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Container = PIXI.Container;
import { merge } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { utilGrid } from "../../utils/grid/utilGrid";
import { logGraphics } from "../../utils/logging/logging";
import { IdIsoSortingGroup } from "./IdIsoSortingGroup";
var IsoSorter = /** @class */ (function (_super) {
    __extends(IsoSorter, _super);
    function IsoSorter(layers) {
        var _this = _super.call(this) || this;
        _this.update = function () {
            logGraphics("Isometry sorting update");
            _this.sortAllGroups(_this.layers, _this.sortingGroups);
        };
        _this.filterIsoLayers = function (layer) {
            return layer.sortingGroup != undefined && layer.sortingGroup !== IdIsoSortingGroup.None;
        };
        _this.startListening = function (layers) {
            _this.stopListening();
            var updates$ = layers.map(function (layer) { return layer.update$; });
            _this.updateSub$ = merge.apply(void 0, updates$).pipe(debounceTime(1))
                .subscribe(_this.update);
        };
        _this.stopListening = function () {
            if (_this.updateSub$ != undefined) {
                _this.updateSub$.unsubscribe();
            }
        };
        _this.filterSortable = function (layer) { return layer.sortingGroup != undefined; };
        _this.createSortingGroups = function (layers) {
            return layers.reduce(function (acc, layer) {
                if (!acc.has(layer.sortingGroup)) {
                    var container = new Container();
                    container.name = "SortingGroup-" + IdIsoSortingGroup[layer.sortingGroup];
                    // FIXME: if different layers fall into same sorting group and have different positions, current setup will fail
                    container.position.set(layer.x, layer.y);
                    _this.addChild(container);
                    acc.set(layer.sortingGroup, container);
                }
                return acc;
            }, new Map());
        };
        _this.sortAllGroups = function (layers, sortingGroups) {
            Array.from(sortingGroups.keys()).forEach(function (sortingGroup) {
                var group = sortingGroups.get(sortingGroup);
                group.removeChildren();
                var objects = _this.getGroupObjects(layers, function (layer) { return layer.sortingGroup === sortingGroup; });
                var displayObjects = utilGrid.topologicalSort(objects).map(function (obj) {
                    obj.display.name = obj.display.name || "IsoId-" + obj.id;
                    return obj.display;
                });
                if (displayObjects.length > 0) {
                    // @ts-ignore
                    group.addChild.apply(group, displayObjects);
                }
            });
        };
        _this.getGroupObjects = function (layers, filter) {
            var objects = [];
            var filteredLayers = filter ? layers.filter(filter) : layers;
            filteredLayers.forEach(function (layer, idx) {
                var isoObjects = layer.getObjects().map(function (val) {
                    var obj = layer.getIsoObject(val);
                    obj.id += idx * 1000;
                    return obj;
                });
                objects.push.apply(objects, isoObjects);
                layer.removeChildren();
            });
            return objects;
        };
        _this.layers = layers.filter(_this.filterIsoLayers);
        _this.sortingGroups = _this.createSortingGroups(_this.layers);
        var groups = Array.from(_this.sortingGroups.keys())
            .sort()
            .map(function (key) { return _this.sortingGroups.get(key); });
        if (groups.length > 0) {
            // @ts-ignore
            _this.addChild.apply(_this, groups);
        }
        _this.sortAllGroups(_this.layers, _this.sortingGroups);
        _this.startListening(_this.layers);
        _this.name = "IsoSorter";
        return _this;
    }
    return IsoSorter;
}(Container));
export { IsoSorter };



//////////////////
// WEBPACK FOOTER
// ./src/features/iso/IsoSorter.ts
// module id = 2226
// module chunks = 3